/* iGlow kvantumskort v3 (06.09.2026)
   - Klikk på et Kite-kort (.gfgVDv2-radio-card) på produktsiden legger valgt antall rett i handlekurven via temaets kjøpsknapp.
   - v2: klikk på et kort bak den åpne kurvskuffens bakgrunn lukker skuffen og velger kortet.
   - v3: når Kite tar over add-to-cart (valgt nivå) får ikke temaets mini-cart HTML-en sin; skriptet henter derfor sidekurv-seksjonene selv etter at kurven er oppdatert og tegner skuffen (varer, rabatt, gratisgave-valg). */
(function () {
  if (window.__iglowKvantumskortDirekte) return;
  window.__iglowKvantumskortDirekte = true;
  var busy = false;

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function refreshDrawer() {
    var mc = document.querySelector('mini-cart');
    if (!mc || typeof mc.renderContents !== 'function') return;
    fetch('/?sections=mini-cart,cart-icon-bubble,mobile-cart-icon-bubble', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        mc.renderContents({ sections: sections });
        try { document.dispatchEvent(new CustomEvent('cartdrawer:opened')); } catch (e) {}
      })
      .catch(function () {});
  }

  function whenCartChanged(prev, cb) {
    var tries = 0;
    (function poll() {
      getCart().then(function (c) {
        if (c.item_count !== prev.item_count || c.total_price !== prev.total_price) { cb(); }
        else if (++tries < 16) { setTimeout(poll, 500); }
        else { cb(); }
      }).catch(function () { cb(); });
    })();
  }

  function addFromCard(card) {
    var form = card.closest('form[action*="/cart/add"]');
    if (!form) return; /* kun widget inne i produktskjemaet, ikke i kurvskuffen */
    var btn = form.querySelector('.product-form__submit') || form.querySelector('button[type="submit"][name="add"]') || form.querySelector('button[type="submit"]');
    if (!btn || btn.disabled || busy) return;
    busy = true;
    getCart().catch(function () { return { item_count: -1, total_price: -1 }; }).then(function (prev) {
      /* la Kite oppdatere antall først (Kite lytter også på document click), deretter trykk kjøpsknappen */
      setTimeout(function () {
        try { btn.click(); } catch (err) {}
        setTimeout(function () { busy = false; }, 1500);
        whenCartChanged(prev, function () { setTimeout(refreshDrawer, 700); });
      }, 300);
    });
  }

  /* 1) Direkte klikk på kort */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var card = t.closest('.gfgVDv2-radio-card');
    if (!card) return;
    addFromCard(card);
  }, false);

  /* 2) Klikk på kurvskuffens bakgrunn (summary) mens skuffen er åpen: finn kortet under pekeren, la skuffen lukke, klikk så kortet */
  document.addEventListener('click', function (e) {
    var det = document.querySelector('details.cart-drawer-container');
    if (!det || !det.open) return;
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('.gfgVDv2-radio-card')) return;
    if (!t.closest('details.cart-drawer-container summary')) return;
    if (!document.elementsFromPoint) return;
    var els = document.elementsFromPoint(e.clientX, e.clientY);
    var under = null;
    for (var i = 0; i < els.length; i++) {
      if (els[i].closest && els[i].closest('.gfgVDv2-radio-card')) { under = els[i].closest('.gfgVDv2-radio-card'); break; }
    }
    if (!under || !under.closest('form[action*="/cart/add"]')) return;
    setTimeout(function () { try { under.click(); } catch (err) {} }, 450);
  }, true);
})();
